import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Footer,
  SpecialOfferBanner,
  Hero,
  PropertyOverview,
  FloorplansList,
  AmenitiesList,
  NeighborhoodCallout,
  WhyQuinn,
  LifestyleHighlights,
  VisitUs,
  PageHero,
  AmenityHighlights,
  AhaBand,
  AmenityGroups,
  PetPolicy,
  Reviews,
  ReviewThemes,
  ReviewsList,
  NextStep,
  AroundTheArea,
  SchoolsNearby,
  NearbyCommunities,
  PrivacyPolicyContent,
  AccessibilityStatement,
  HyperlocalHero,
  HyperlocalPageCopy,
  FaqSearch,
  FaqCategoryBar,
  FaqList,
  FaqHelp,
  FloorPlansHero,
  FloorPlansCompare,
  InteractiveMapCallout,
  TourOptions,
  GalleryCategoryBar,
  GalleryMosaic,
  HomeFeatures,
  FeesAndPets,
  FeeTotals,
  FeeTable,
  FeeEstimate,
  FeeDisclosure,
  Fees,
  PetRules,
  TourHero,
  TourScheduler,
  TourSteps,
  TourGallery,
  TourQuestions,
  ContactDetails,
  VirtualTourEmbed,
  SitemapList,
  EngrainSitemapEmbed,
} from './components';
import './styles/quinn.css';

export const registry: ComponentRegistry = {
  Header,
  Footer,
  SpecialOfferBanner,
  Hero,
  PropertyOverview,
  FloorplansList,
  AmenitiesList,
  NeighborhoodCallout,
  WhyQuinn,
  LifestyleHighlights,
  VisitUs,
  PageHero,
  AmenityHighlights,
  AhaBand,
  AmenityGroups,
  PetPolicy,
  Reviews,
  ReviewThemes,
  ReviewsList,
  NextStep,
  AroundTheArea,
  SchoolsNearby,
  NearbyCommunities,
  PrivacyPolicyContent,
  AccessibilityStatement,
  HyperlocalHero,
  HyperlocalPageCopy,
  FaqSearch,
  FaqCategoryBar,
  FaqList,
  FaqHelp,
  FloorPlansHero,
  FloorPlansCompare,
  InteractiveMapCallout,
  TourOptions,
  GalleryCategoryBar,
  GalleryMosaic,
  HomeFeatures,
  FeesAndPets,
  FeeTotals,
  FeeTable,
  FeeEstimate,
  FeeDisclosure,
  Fees,
  PetRules,
  TourHero,
  TourScheduler,
  TourSteps,
  TourGallery,
  TourQuestions,
  ContactDetails,
  VirtualTourEmbed,
  SitemapList,
  EngrainSitemapEmbed,
};

export default registry;
